import { render, staticRenderFns } from "./new-beneficiary-details.vue?vue&type=template&id=5d351b2c&"
import script from "./new-beneficiary-details.vue?vue&type=script&lang=js&"
export * from "./new-beneficiary-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports